// extracted by mini-css-extract-plugin
module.exports = {"Toast":"Toast_Toast__2ju4R"};